// src/services/aliadosApi.js
// API de aliados comerciales. Ver docs/aliados.md (backend) para el contrato.

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5246';

function tok() { return localStorage.getItem('ecolab_token') || null; }

async function apiGet(path, { auth = false } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth && tok()) headers.Authorization = `Bearer ${tok()}`;
  const res = await fetch(`${BASE}${path}`, { headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || `GET ${path} → ${res.status}`), { data, status: res.status });
  return data;
}

async function apiSend(method, path, body, { auth = false } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth && tok()) headers.Authorization = `Bearer ${tok()}`;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || `${method} ${path} → ${res.status}`), { data, status: res.status });
  return data;
}

// ── Catálogo de tipos de negocio ─────────────────────────────────────
export const getTiposNegocio = (incluirInactivos = false) =>
  apiGet(`/api/ecolab/aliados/tipos-negocio?incluirInactivos=${incluirInactivos}`);

export const crearTipoNegocio = (dto) =>
  apiSend('POST', '/api/ecolab/aliados/tipos-negocio', dto, { auth: true });

export const actualizarTipoNegocio = (id, dto) =>
  apiSend('PUT', `/api/ecolab/aliados/tipos-negocio/${id}`, dto, { auth: true });

// ── Aliados ──────────────────────────────────────────────────────────
export const listarAliados = (params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v != null && v !== '')
  ).toString();
  return apiGet(`/api/ecolab/aliados${qs ? `?${qs}` : ''}`, { auth: true });
};

export const getAliado = (id) => apiGet(`/api/ecolab/aliados/${id}`, { auth: true });

/** Crear aliado. Endpoint público — cooperativa se fija en backend a FENAGRO APL. */
export const crearAliado = (dto) => apiSend('POST', '/api/ecolab/aliados', dto);

export const precheckAliado = (dto) => apiSend('POST', '/api/ecolab/aliados/precheck', dto);

export const actualizarAliado = (id, dto) =>
  apiSend('PUT', `/api/ecolab/aliados/${id}`, dto, { auth: true });

export const getDescuentoEfectivo = (id) =>
  apiGet(`/api/ecolab/aliados/${id}/descuento-efectivo`);

export const aprobarAliado = (id) =>
  apiSend('POST', `/api/ecolab/aliados/${id}/aprobar`, {}, { auth: true });

export const rechazarAliado = (id, motivo) =>
  apiSend('POST', `/api/ecolab/aliados/${id}/rechazar`, { motivo }, { auth: true });

export const toggleMarketplace = (id, visible, motivo) =>
  apiSend('POST', `/api/ecolab/aliados/${id}/marketplace`, { visible, motivo }, { auth: true });

export const togglePOS = (id, visible, motivo) =>
  apiSend('POST', `/api/ecolab/aliados/${id}/pos`, { visible, motivo }, { auth: true });

export const toggleActivoAliado = (id, activo, motivo) =>
  apiSend('POST', `/api/ecolab/aliados/${id}/toggle-activo`, { activo, motivo }, { auth: true });

export const eliminarAliado = (id) =>
  apiSend('DELETE', `/api/ecolab/aliados/${id}`, undefined, { auth: true });

// ── Integraciones (solo SuperAdmin) ──────────────────────────────────
export const listarIntegraciones = () =>
  apiGet('/api/ecolab/integraciones', { auth: true });

export const getIntegracion = (clave) =>
  apiGet(`/api/ecolab/integraciones/${clave}`, { auth: true });

export const actualizarIntegracion = (clave, dto) =>
  apiSend('PUT', `/api/ecolab/integraciones/${clave}`, dto, { auth: true });

export const probarIntegracion = (clave) =>
  apiSend('POST', `/api/ecolab/integraciones/${clave}/probar`, {}, { auth: true });
